export const REQUEST_GET_ALL_MODULE_CODES = 'GET_ALL_MODULE_CODES';
export const REQUEST_GET_ALL_MODULE_CODES_SUCCEEDED = 'GET_ALL_MODULE_CODES_SUCCEEDED';
export const REQUEST_GET_ALL_MODULE_CODES_FAILED = 'GET_ALL_MODULE_CODES_FAILED';

export const REQUEST_UPDATE_ALL_MODULE_CODES = 'UPDATE_ALL_MODULE_CODES';
export const REQUEST_UPDATE_ALL_MODULE_CODES_SUCCEEDED = 'UPDATE_ALL_MODULE_CODES_SUCCEEDED';
export const REQUEST_UPDATE_ALL_MODULE_CODES_FAILED = 'UPDATE_ALL_MODULE_CODES_FAILED';
